import axiosInstance from './axiosInstance';

// Aggregate slip listing across CommissionSlip + IncentiveSlip + ExtraSlip.
// type: All | Commission | Incentive | Other
// scope: all | mine
export const getAllSlips = (type = 'All', scope = 'all') =>
    axiosInstance.get('/Slip/all', { params: { type, scope } }).then(r => r.data);
